import { mutatorAction } from "satcheljs";
import { addMinutes, getMinutes, now, startOfMinute } from "owa-datetime";
import { getStore } from "../store/store";
import type { CalendarSchedulingEntrySource, SchedulingTimeRange } from "../store/store";

export const openCalendarSchedulingDialogMutator: (entrySource: CalendarSchedulingEntrySource, timeRange?: SchedulingTimeRange) => void = mutatorAction("OPEN_CALENDAR_SCHEDULING_DIALOG", (entrySource: CalendarSchedulingEntrySource, timeRange?: SchedulingTimeRange): void => {
    const store = getStore();
    store.entrySource = entrySource;
    if (timeRange) {
        store.timeRange = timeRange;
    }
    else {
        const currentTime = now();
        const start = addMinutes(startOfMinute(currentTime), 30 - (getMinutes(currentTime) % 30));
        store.timeRange = { start, end: addMinutes(start, 30) };
    }
    store.isOpen = true;
});

export const closeCalendarSchedulingDialogMutator: () => void = mutatorAction("CLOSE_CALENDAR_SCHEDULING_DIALOG", (): void => {
    const store = getStore();
    store.isOpen = false;
    store.entrySource = undefined;
    store.timeRange = undefined;
});
